"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemDropComponent = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class ItemDropComponent extends gotti_1.Component {
    constructor(itemName, itemData) {
        super(Constants_1.SYSTEMS.ITEM_DROP);
        this.itemName = itemName;
        this.itemData = itemData;
    }
}
exports.ItemDropComponent = ItemDropComponent;
//# sourceMappingURL=module.js.map